import type { Group, Scene } from 'three';
import { trafficMesh } from '../entities/vehicles/catalog';
import { headingOf } from '../systems/steering';
import type { TrafficCar } from './RunState';

/** Keeps one mesh per live traffic car. */
export class TrafficView {
  private readonly meshes = new Map<number, Group>();

  constructor(private readonly scene: Scene) {}

  sync(traffic: readonly TrafficCar[]): void {
    const alive = new Set<number>();
    for (const car of traffic) {
      alive.add(car.id);
      let mesh = this.meshes.get(car.id);
      if (!mesh) {
        mesh = trafficMesh(car.kind, car.variant);
        this.meshes.set(car.id, mesh);
        this.scene.add(mesh);
      }
      // The simulation steers cars smoothly; the nose follows the direction of travel.
      mesh.position.set(car.x, 0, -car.s);
      mesh.rotation.y = -headingOf(car.vx, car.speed) + (car.spin ?? 0);
    }
    for (const [id, mesh] of this.meshes) {
      if (alive.has(id)) continue;
      this.scene.remove(mesh);
      this.meshes.delete(id);
    }
  }

  clear(): void {
    for (const mesh of this.meshes.values()) this.scene.remove(mesh);
    this.meshes.clear();
  }
}
